import React, { useEffect } from 'react'

import { AppAntSwitch } from '@components'
import { showFeatures, acriss, mileage, transmission, fuelPolicy, insurance, prepaid, inTerminal, webSuppliers } from '@signals'
import { useComputed } from '@preact/signals-react'


export default function ShowFeatures({ watchAcriss = true, ...props }) {
	const hasValue = (val) =>
		Array.isArray(val) ? val.length > 0 : !!val

	const mustOpen = useComputed(() =>
		(watchAcriss && hasValue(acriss.value)) ||
		hasValue(mileage.value) ||
		hasValue(transmission.value) ||
		hasValue(fuelPolicy.value) ||
		hasValue(insurance.value) ||
		hasValue(prepaid.value) ||
		hasValue(inTerminal.value) ||
		hasValue(webSuppliers.value)
	)


	useEffect(() => {
		if (mustOpen.value) showFeatures.value = mustOpen.value
	}, [mustOpen.value])

	return <AppAntSwitch
		falseText="Hide features"
		trueText="Show features"
		checked={showFeatures.value}
		onChange={newValue => showFeatures.value = newValue.target.checked}
		{...props}
	/>
}